export interface Review {
  name: string;
  school: string;
  quote: string;
}

export const defaultReviews: Review[] = [
  {
    name: 'Lorraine',
    school: 'Scotch College',
    quote:
      'Lesson preparation is super easy. Video clips bring the syllabus alive. The short tests challenge the learner to acquire knowledge and the practical activities reinforce the content. ',
  },
  {
    name: 'Danny',
    school: 'Marian Catholic College',
    quote:
      'Stile has changed the way I teach my classes. The interactive activities, clips and ability to set my own informal tasks on Stile have made our learning experience easy and exciting.',
  },
  {
    name: 'Rob',
    school: 'MacKillop College',
    quote:
      'Stile allows me to get out of the way of the students who can learn independently and give more assistance to those who are struggling.',
  },
  {
    name: 'Lucy',
    school: 'Marian Catholic College',
    quote:
      'Stile has brought imagination to my classroom with virtual reality and simulations. I love seeing the students engage with the real life contexts given in the creative lessons.',
  },
  {
    name: 'Emma',
    school: 'Trinity College',
    quote:
      'Stile maximises the engagement of students by providing regular opportunities for participating in critical thinking and discussions, and receiving frequent, personalised feedback.',
  },
  {
    name: 'Andy',
    school: 'Rehoboth Christian College',
    quote:
      "Stile captivates my students' interest with their activities, quizzes, investigations and videos in each topic and provokes my students towards high-order thinking. Love it!",
  },
  {
    name: 'Heath',
    school: 'Hale School',
    quote:
      'The tasks are well structured, include up-to-date real world information, cover a range of skills as well as providing the students with timely, relevant feedback.',
  },
  {
    name: 'Peter',
    school: 'The Hutchins School',
    quote:
      'I love the lesson editing, it has made differentiation far easier to achieve, enabling changes to be targeted. The model answers have saved so much of my time.',
  },
  {
    name: 'Owen',
    school: 'Terang College',
    quote:
      'There are few developed resources for Year 7-10 that are comparable to Stile. Having structured lessons with an interactive canvas is helpful in organising, monitoring and differentiating.',
  },
  {
    name: 'Rhonda',
    school: 'Marian College',
    quote:
      'Stile is a powerful online resource in my Year 7 Science classes. I appreciate how the platform allows me to tailor content to my needs, and provides live data on student progress. ',
  },
];
